export default "__VITE_ASSET__C$eCh44w__"